import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { StyleSheetManager } from 'styled-components';

import { useNetworkStatus } from 'hooks/common';

import { addQACommandsToWindow } from 'helpers/qaCommands';
import { isProd } from 'helpers/utils';
import { setParamsToWindow } from 'helpers/window';

import { PageLoader } from 'components/PageLoader';

import Notifications from './components/Notifications';
import { useSelector } from './hooks';
import router from './router';
import { EppoGate } from './services/Eppo';
import useI18next from './services/i18n';
import { createProcessingSelector } from './store/loading/selectors';
import { OPEN_SUPPORT_FORM } from './store/user/actionTypes';
import ThemeProvider from './theme/provider';

function App() {
    if (!isProd()) addQACommandsToWindow();

    const { isTranslationsLoaded } = useI18next();

    useNetworkStatus();

    setParamsToWindow();
    const isLoadingSupportForm = useSelector(createProcessingSelector([OPEN_SUPPORT_FORM]));

    return (
        isTranslationsLoaded && (
            <StyleSheetManager>
                <ThemeProvider>
                    <Notifications />
                    <EppoGate>
                        {isLoadingSupportForm ? (
                            <PageLoader />
                        ) : (
                            <Suspense fallback={<PageLoader />}>
                                <RouterProvider router={router} />
                            </Suspense>
                        )}
                    </EppoGate>
                </ThemeProvider>
            </StyleSheetManager>
        )
    );
}

export default App;
